import { render, staticRenderFns } from "./BookListpdf.vue?vue&type=template&id=a3370542&scoped=true&"
import script from "./BookListpdf.vue?vue&type=script&lang=js&"
export * from "./BookListpdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3370542",
  null
  
)

export default component.exports